import React from "react";
import { Link, useLocation } from "react-router-dom";

const Monitoring = () => {
  const location = useLocation();


  const renderNavItem = (to, label, iconClass) => {
    const isActive = location.pathname === to;

    return (
      <li
        className={`kt-menu__item ${isActive ? "kt-menu__item--active" : ""}`}

        key={to}
      >
        <Link className="kt-menu__link" to={to}>
          <i className={`kt-menu__link-icon ${iconClass}`}></i>
          <span className="kt-menu__link-text">{label}</span>
        </Link>
      </li>
    );
  };

  return (
    <>
      {renderNavItem(
        "/monitoring/stock",
        "Monitoring Stock",
        " flaticon2-soft-icons "
      )}
      {renderNavItem(
        "/monitoring/cctv",
        "Monitoring CCTV",
        "flaticon2-photograph"
      )}
      {renderNavItem(
        "/monitoring/user-activity",
        "Monitoring User Activity",
        "flaticon2-avatar"
      )}

      {/* {renderNavItem("/monitoring/opname", "Stock Opname", "flaticon2-reload")}
      {renderNavItem(
        "/other/pindah-lot",
        "Pindah Lokasi",
        " flaticon2-files-and-folders "
      )} */}
    </>
  );
};

export default Monitoring;
